import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Label Component - Global UI Typography Rules
 * 
 * Per Global UI & Layout Enforcement:
 * - Form Label: 12px
 */
export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      // Form Label: 12px per Global UI Typography Rules
      className={cn(
        "ui-form-label leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className
      )}
      {...props}
    />
  )
);
Label.displayName = "Label";

export { Label };
